import {ItemTypes} from "../../constants";
import SocialWallPhoto from "./SocialWallPhoto";
import React, {memo} from "react";
import SocialWallMessage from "./SocialWallMessage";

const SocialWallItem = ({item}) => {
    if(item.type === ItemTypes.PHOTO)
        return <SocialWallPhoto item={item}/>
    else return <SocialWallMessage message={item}/>
}

export default memo(SocialWallItem)